var p = Object.prototype;
function e(t) {
  var o = t && t.constructor, r = typeof o == "function" && o.prototype || p;
  return t === r;
}
var c = e;
export {
  c as default
};
//# sourceMappingURL=_isPrototype.js.map
